import { AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { ContextMenu } from 'primeng/contextmenu';
import { ContextMenuModule } from 'primeng/contextmenu';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { ModalService } from '../../../../@core/services/modal/modal.service';
import { ShortcutRecordDialogComponent } from '../shortcut-record-dialog/shortcut-record-dialog.component';
import { ShortcutRegistryService } from '../../services/shortcut-registry.service';

@Component({
  selector: 'app-shortcut-context-menu-host',
  template: '<p-contextMenu #shortcutContextMenu [model]="[]" appendTo="body" [attr.data-testid]="\'shortcut-context-menu\'"></p-contextMenu>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ContextMenuModule]
})
export class ShortcutContextMenuHostComponent implements AfterViewInit, OnInit {
  @ViewChild('shortcutContextMenu') shortcutContextMenu!: ContextMenu;
  private readonly shortcutRegistry = inject(ShortcutRegistryService);
  private readonly modalService = inject(ModalService);
  private readonly i18n = inject(I18nService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.shortcutRegistry.openShortcutDialogRequest$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ buttonId, currentCombos, onComplete }) => {
        this.modalService
          .fromComponent(ShortcutRecordDialogComponent, {
            title: this.i18n.translate(_('hotkeys.set-shortcut')),
            size: 'sm',
            closable: true,
            setLocalsSig: { buttonId, currentCombos }
          })
          .subscribe(onComplete);
      });
  }

  ngAfterViewInit(): void {
    this.shortcutRegistry.setContextMenuRef(this.shortcutContextMenu);
  }
}
